import { CardSection } from "containers/Manual/components/section/CardSection";
import { Img } from "containers/Manual/components/content/Image";
import { Li } from "containers/Manual/components/list/Li";
import { ListSection } from "containers/Manual/components/section/ListSection";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Ul } from "containers/Manual/components/list/Ul";
import { ImgRoute } from "contents/Images";

export const AND = () => {
  return (
    <CardSection id="AND" title="AND">
      <Paragraph>
        표현식 내의 모든 인수가 <b>TRUE</b>로 평가되는지 확인합니다. 모든 인수가
        참이면 <b>TRUE</b> 값이 반환됩니다
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>AND(ARGUMENT_1, [ARGUMENT_2, ...])</Paragraph>
        <Ul>
          <Li>
            <b>ARGUMENT_1</b>은 평가할 인수입니다.
          </Li>
          <Li>
            <b>ARGUMENT_2, ... [선택 사항]</b>은 추가 인수입니다.
          </Li>
        </Ul>
      </ListSection>
      <ListSection title="Example">
        <Paragraph accent>
          AND(`model` == "4 Series", `year` &gt; 2015)
        </Paragraph>
        <Img src="computeAnd" />
      </ListSection>
      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>ARGUMENT</b>는 <b>TRUE</b> 또는 <b>FALSE</b>, 두 값 중
          하나를 포함하는 열 또는 두 값 중 하나를 반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>
          <b>AND</b> 함수는 대소문자를 구분하지 않으므로 True, TRUE, true를
          동일한 방식으로 처리합니다. 마찬가지로 False, FALSE, false도 동일하게
          처리됩니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
